import Vue from 'vue'
import Router from 'vue-router'
import PageNotFound from '@/views/PageNotFound'
import UserService from '@/services/UserService'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/live'
    },
    {
      path: '/login',
      name: 'login',
      meta: { layout: 'default', title: 'Login' },
      component: require('@/views/Login').default // load sync
    },
    {
      path: '/daily',
      name: 'dailyJournal',
      meta: { layout: 'default', title: 'Daily' },
      component: require('@/views/dailyJournal/dailyJournal').default // load sync
    },
    {
      path: '/live',
      name: 'live',
      meta: { layout: 'default', title: 'Reports Main' },
      component: require('@/views/live/MainReport.vue').default, // load sync
      redirect: '/live/home',
      children: [
        {
          path: 'home',
          component: require('@/views/live/HomeReport.vue').default,
          meta: { layout: 'default', title: '' }
        },
        {
          path: 'location/:location_id',
          component: require('@/views/live/LocationReport.vue').default,
          meta: { layout: 'default', title: '' }
        },
        {
          path: 'location/:location_id/labor',
          name: 'laborReport',
          component: require('@/views/live/LocationLaborReport.vue').default,
          meta: { layout: 'default', title: '' }
        },
        {
          path: 'location/:location_id/sales',
          component: require('@/views/live/LocationSalesReport.vue').default,
          meta: { layout: 'default', title: '' }
        },
        {
          path: 'location/:location_id/tickets',
          component: require('@/views/live/LocationTicketReport.vue').default,
          meta: { layout: 'default', title: '' }
        }
      ]
    },
    { path: '*', component: PageNotFound }
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = UserService.loggedIn()

  if (authRequired && !loggedIn) {
    return next('/login')
  }

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = 'eFish - ' + nearestWithTitle.meta.title

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

router.name = 'router'

export default router
